import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, message } from 'antd';
import { BannerZoneEditor } from '../../../../components';
import { DESIGN_PAGE_LINK_TYPES_LIST } from '../../../../constants/page-design';

const HotSelectorCom: React.FC<any> = (props) => {
    const [visible, setVisible] = useState<boolean>(false);
    const [backPic, setBackPic] = useState(''); // 图片地址
    const [hotZoneList, setHotZoneList] = useState<any[]>([]);
    const [imgWh, setImgWh] = useState<any>({});
    const [isInit, setIsInit] = useState<boolean>(false);
    const [randomKey] = useState(props.uuid || Math.random()); // 创建唯一值

    useEffect(() => {
        if (props?.value?.pic !== backPic) {
            if (typeof props?.value?.pic === 'string') {
                setBackPic(props?.value?.pic);
            } else {
                setBackPic('');
            }
            const linkParams = props?.value?.linkParams || {};
            const { hotZoneList = [], imgWh = {} } = linkParams;
            setHotZoneList(hotZoneList);
            setImgWh(imgWh);
        }
        setTimeout(() => {
            setIsInit(true);
        }, 300);
    }, [props?.value?.pic]);

    const handleChangeHot = (value: any) => {
        const newHotZoneList = value.hotZoneList || [];
        const imgWhData = value.imgWh || imgWh;
        setImgWh(imgWhData);
        const { onChange } = props;
        if (value.hotZoneList) {
            onChange({ hotZoneList: newHotZoneList, imgWh: imgWhData });
            setHotZoneList(newHotZoneList);
        } else {
            onChange({ imgWh: imgWhData, hotZoneList });
        }
    };

    const handleEditHotZone = (flag: boolean) => {
        if (!backPic) {
            message.warning('请先上传图片！');
            return;
        }
        if (flag) {
            const hotVisible = !!backPic && backPic.includes('https');
            setVisible(hotVisible);
        } else {
            setVisible(false);
        }
    };

    return (
        <span className="link-name">
            <div style={{ display: 'inle-flex', alignItems: 'center' }}>
                <Button
                    style={{ marginRight: 10 }}
                    onClick={() => {
                        handleEditHotZone(true);
                    }}
                    className="link-type-edit"
                >
                    添加热区
                </Button>
                <span style={{ color: '#FFB058' }}>当前创建了{hotZoneList.length}个热区</span>
                <BannerZoneEditor
                    form={props?.form}
                    bannerKey={randomKey}
                    wrapName={'entry'}
                    result={'hotZoneList'}
                    linkTypes={DESIGN_PAGE_LINK_TYPES_LIST}
                    visible={visible}
                    maxCount={20}
                    linkTypeMode="select"
                    imgUrl={backPic}
                    hotZoneList={hotZoneList}
                    onChange={(value) => {
                        console.log(value, '我是value哦');
                        if (isInit) {
                            handleChangeHot(value);
                        }
                    }}
                    onClose={() => handleEditHotZone(false)}
                    isFormTrigger={true}
                />
            </div>
        </span>
    );
};

export const HotSelector = Form.create<any>()(HotSelectorCom);
export default HotSelector;
